import { pluralize } from '@skbkontur/staff-common';
export const getPageSize = () => {
    const min = 10;
    const pageSize = Math.floor((window.innerHeight - 72 - 80 - 48 - 56 - 32 - 24) / 48);
    return Math.max(pageSize, min);
};
export const pluralizeSelected = (count) => pluralize(count, ['Выбран', 'Выбрано', 'Выбрано']);
